import Logger from '../services/Logger';

const logger = new Logger('redux');

export default logger;
